// import Choices and modules
import Choices from 'choices.js';
// import 'choices.js/src/styles/choices.scss';

export default Choices;
